<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-profile"></i> SVN相关</el-breadcrumb-item>
                <el-breadcrumb-item>人员管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class="container" style="min-width: 900px"> 
            <div class="handle-box">
                <div class="plugins-tips">
                    <el-input v-model="query.name" placeholder="Filter" @keyup.enter.native="handleSearch" class="handle-input mr10"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                    <span style="margin-left: 20px; color: #67C23A; font-size: 15px">查询条件："用户名"、"昵称"</span> 
                </div>
            </div>

            <div class="hovertable">
                <el-table
                :data="tableDataPer"
                class="table"
                v-loading="loading"
                ref="multipleTable"
                :cell-style="{ textAlign: 'center'}"
                :header-cell-style="{textAlign: 'center'}"
                header-cell-class-name="table-header"
                >   
                    <el-table-column prop="id" label="ID" align="center" width="150px"></el-table-column>
                    <el-table-column prop="username" label="用户名" width="200px"></el-table-column>
                    <el-table-column prop="realUserName" label="昵称" width="200px"></el-table-column>
                    <el-table-column prop="description" label="描述"></el-table-column>
                    <el-table-column prop="project" label="所属项目" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="Operation" prop="code" width="200px">
                        <template slot-scope="scope">
                            <el-button type="primary" icon="el-icon-edit" :loading="scope.row.loading" size="mini" @click="showEditSvnUser(scope.row)"></el-button>
                            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteSvnUser(scope.row.id)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    :current-page="pageIndex"
                    @size-change="handleSizeChange"
                    :page-sizes="[5 ,20, 40, 80, 120]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getPersonnelInfoList, getPersonnelInfo, deletePersonnelInfo, getAuthorization } from '../../api/svnAPI.js'
export default {
    name: 'svnManage',
    data() {
        return {
            //SVN 服务地址
            serviceUrl: localStorage.getItem(localStorage.getItem('ms_username') + 'ServiceUrl'),

            query: {
                name: '',  //搜索框值
            },

            proejcts: [],  // 项目和人员集合

            tableData: [], //el-table集合  用于持久化数据
            tableDataSea: [], //el-table 用于存储搜索的数据
            tableDataPer: [], //el-table 用于展示集合

            pageTotal: 0,  //总数据量
            pageSize: 20,  //单页数据量
            pageIndex: 1, //页码

            loading: true,  // table列表

            //身份令牌
            sessId : localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
        };
    },
    created() {
        // 获取项目集合
        this.getProejcts()
        this.getData()
    },
    //router 每次跳转进来 都会执行
    activated() {
        this.sessId = localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
        this.getData()
    },
    methods: {

        //获取数据
        getData () {
            let params = {'url': this.serviceUrl, 'sessId': this.sessId}
            
            getPersonnelInfoList(params).then(res => {
                //清空缓存
                this.tableData = [] 

                if (res.data.code == 200) {
                    //将返回数据分割成数组    ‘['1|admin', 'Super Administrator', 'admin user']  → ['2|TEST', 'TEST1', '描述测试']’
                    this.tableData2 = res.data.data.data.split('],')
                    let data = ''
                    let jsonStr = ''
                    for (let i = 0; i < this.tableData2.length; i++) {
                        //将单条数据 转成 数组
                        data = this.tableData2[i].split(',')
                        
                        //提取 用户ID 和 用户名
                        let id = data[0].slice(2, data[0].indexOf('|'))
                        let username = data[0].slice(data[0].indexOf('|') + 1, data[0].lastIndexOf('\''))

                        // 获取所属项目组
                        let proejct = ''
                        for (let i = 0; i < this.proejcts.length; i++) {
                            if (this.proejcts[i].personnels.indexOf(username) != -1) {
                                proejct += this.proejcts[i].projectName + ', '
                            }
                        }

                        //拼接成json对象  
                        jsonStr = { id: id, username: username, 
                            realUserName: data[1].slice(2, data[1].lastIndexOf('\'')) ,
                            project: proejct,
                            description: data[2].slice(2, data[2].lastIndexOf('\'')), 
                            loading: false }
                        //存入json集合
                        this.tableData.push(jsonStr)
                        this.tableDataPer = this.tableData
                    }
                    //对数据分页过滤
                    this.filterData(this.query.name, this.pageIndex)
                } else if (res.data.code == 777) {
                    this.$message.warning(res.data.message)
                    this.loginDialogVisible = true
                }
            })

            this.loading = false
        },

        // 获取项目集合
        getProejcts () {
            let params = {'url': this.serviceUrl, 'sessId': this.sessId}
            getAuthorization(params).then(res => {
                if (res.data.code == 200) {
                    let jsonStr

                    let fileContent = res.data.data.fileContent.substring(0, res.data.data.fileContent.indexOf('[/]'))
                    fileContent.trim().split('\n').forEach(line => {
                        if (line.indexOf('=') != -1) {
                            // 临时变量
                            let projectName = line.substring(0, line.indexOf('='))
                            let cnName = ''

                            //personnels 结尾如果有逗号, 就清理掉
                            let personnels = line.substring(line.indexOf('=') + 1, line.length)
                            if (personnels.substring(personnels.length - 1, personnels.length) == ',') {
                                personnels = personnels.substring(0, personnels.length - 1)
                            }
                            
                            //拼接数据
                            jsonStr = { 'projectName': projectName, 'personnels': personnels }
                            this.projects = this.proejcts.push(jsonStr)
                        }
                    });

                } else if (res.data.code == 777) {
                    this.$message.error(res.data.message)
                }
            })
        },

        // 搜索
        handleSearch () {
            this.pageIndex = 1
            this.filterData(this.query.name, this.pageIndex);
        },

        //数据分页处理
        filterData(name, pageIndex) {
            this.loading = true
            this.tableDataPer = []  //清空缓存

            //所有数据
            if (name == undefined || name == '') {
                //获得当前 页数据
                for(let i = this.pageSize * (pageIndex - 1); i < this.pageSize * pageIndex; i++) {
                    if (this.tableData[i] != undefined) {
                        this.tableDataPer = this.tableDataPer.concat(this.tableData[i])
                    }
                }
                this.pageTotal = this.tableData.length
                this.loading = false

            } else {
                //过滤搜索数据
                this.tableDataSea = []
                this.tableData.forEach(item => {
                    //模糊查询
                    if (item.username.toUpperCase().indexOf(name.toUpperCase()) != -1 || item.realUserName.toUpperCase().indexOf(name.toUpperCase()) != -1) {
                        this.tableDataSea = this.tableDataSea.concat(item)
                    }
                })
                //获得当前 页数据
                for(let i = this.pageSize * (pageIndex - 1); i < this.pageSize * pageIndex; i++) {
                    if (this.tableDataSea[i] != undefined) {
                        this.tableDataPer = this.tableDataPer.concat(this.tableDataSea[i])
                    }
                }
                
                this.pageTotal = this.tableDataSea.length
                this.loading = false
            }
        },

        //编辑Svn用户
        showEditSvnUser(row) {
            row.loading = true
            //验证是否有权限
            let params = {'id': row.id, 'url': this.serviceUrl, 'sessId': this.sessId}
            //发送请求
            getPersonnelInfo(params).then(res => {
                //权限通过进行跳转到修改页 
                if (res.data.code == 200) {
                    row.loading = false
                    localStorage.setItem('svnEditId', row.id)
                    if (row.id != undefined && row.id != '') {
                        this.$router.push({
                            name: `/SvnEdit`,
                        })
                    }
                } else if (res.data.code == 777) {
                    row.loading = false
                    this.$message.warning(res.data.message)
                    this.loginDialogVisible = true
                } else if (res.data.code == 721)  {
                    row.loading = false
                    this.$message.warning('你没有执行此任务的授权')
                    this.$router.push('/svnManage')
                } else {
                    row.loading = false
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                row.loading = false
            })
        },

        //删除Svn用户
        deleteSvnUser(id) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                let params = { 'id': id, 'url': this.serviceUrl, 'sessId': this.sessId }
                deletePersonnelInfo(params).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("删除成功")
                        this.getData()
                    } else if (res.data.code == 777){
                        this.$message.warning(res.data.message)
                        this.loginDialogVisible = true
                    } else if (res.data.code == 721) { 
                        this.$message.warning('你没有执行此任务的授权')
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch (error =>{
                    console.log (error)
                })
            })
        },

        // 分页导航
        handlePageChange(val) {
            this.$set(this, "pageIndex", val);
            this.filterData(this.query.name, val);
        },

        //自定义页大小
        handleSizeChange(val) {
            this.pageSize = val
            this.filterData(this.query.name, this.pageIndex);
        },

        //把每一行的索引放进row
        tableRowClassName({row, rowIndex}) {
            row.index = rowIndex
        },
    }
};
</script>

<style scoped lang="scss">
/* 鼠标悬浮 */
::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td {
//  background-color: #212e3e !important;
    cursor: pointer;
}
// ------------------------------------- 布局 End 

.plugins-tips {
    &:nth-child(2) {
        margin-left: 35px;
        padding-left: 30px;
    }
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
    border-radius: 5px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
